import { Box, Text, ToggleSwitch } from '@bechtel/gds';
import { find, findIndex, map } from 'lodash';
import { FC } from 'react';
import { css } from 'styled-components';

//import { multiplePermissionScope, nonePermissionScope } from '../../form-data';
//import { MultipleScopeIcon } from '../../multiple-scope-icon';
import {
  ExpandCollapseIconStyled,
  ModuleEmptyItemStyled,
  ModuleRowStyled,
  ModuleStyled,
  PermissionRowStyled,
  PermissionStyled,
  StickyColumnStyled,
  ToggleSwitchContainerStyled,
} from './styled';
import { MatrixItemProps } from './types';

export const MatrixItem: FC<MatrixItemProps> = ({
  moduleItem,
  selectedRoles,
  moduleIndex,
  rolePermissionScopeList,
  onPermissionSelect,
  collapseModules,
  onExpandCollapseModule,
  lstItemRefrence,
}) => {
  const collapseModule = find(collapseModules, (item) => {
    return item.moduleId === moduleItem.moduleId;
  });
  const collapseMe = collapseModule?.collapsed ? collapseModule?.collapsed : false;
  const isPermissionEnabled = (permissionId: string, roleId: string) => {
    return (
      findIndex(rolePermissionScopeList, (item) => {
        return item.permissionId === permissionId && item.roleId === roleId;
      }) >= 0
    );
  };
  return (
    <div
      ref={(element) => {
        if (lstItemRefrence?.current && element) lstItemRefrence.current[moduleItem.moduleId] = element;
      }}
      key={moduleItem.moduleId}
    >
      <ModuleRowStyled>
        <td colSpan={2}>
          <table>
            <tbody>
              <PermissionRowStyled>
                <StickyColumnStyled
                  css={`
                    ${({ theme }) =>
                      css`
                        background-color: ${theme.colors.grey[100]};
                      `}
                  `}
                >
                  <ModuleStyled onClick={() => onExpandCollapseModule(moduleItem.moduleId)}>
                    <Text weight="600" size="300" color="black">
                      {moduleItem.moduleName}
                    </Text>
                    <ExpandCollapseIconStyled
                      fillColor="grey.600"
                      icon={collapseMe ? 'chevron-right' : 'chevron-down'}
                    />
                  </ModuleStyled>
                </StickyColumnStyled>
                <td style={{ verticalAlign: 'middle' }}>
                  <Box>
                    {map(selectedRoles, (roleItem) => {
                      return <ModuleEmptyItemStyled key={roleItem.id}>&nbsp;</ModuleEmptyItemStyled>;
                    })}
                  </Box>
                </td>
              </PermissionRowStyled>
            </tbody>
          </table>
        </td>
      </ModuleRowStyled>
      <tr style={collapseMe ? { visibility: 'collapse' } : { visibility: 'visible' }} key={'tr' + moduleItem.moduleId}>
        <td colSpan={2}>
          {map(moduleItem.permissions, (permissionItem, permissionIndex) => {
            return (
              <table>
                <tbody>
                  <PermissionRowStyled key={permissionItem.id}>
                    <StickyColumnStyled
                      css={`
                        ${({ theme }) =>
                          css`
                            background-color: ${theme.colors.white};
                          `}
                      `}
                    >
                      <PermissionStyled>
                        <Text size="400" color="black">
                          {permissionItem.description}
                        </Text>
                      </PermissionStyled>
                    </StickyColumnStyled>
                    <td style={{ verticalAlign: 'middle' }}>
                      <Box>
                        {map(selectedRoles, (roleItem) => {
                          return (
                            <ToggleSwitchContainerStyled
                              key={`${moduleItem.moduleId}-${permissionItem.id}-${roleItem.id}`}
                            >
                              <ToggleSwitch
                                key={`${moduleItem.moduleId}-${permissionItem.id}-${roleItem.id}- ${permissionIndex}`}
                                disabled={false}
                                isToggled={isPermissionEnabled(permissionItem.id, roleItem.id)}
                                onToggle={() => {
                                  onPermissionSelect(roleItem.id, permissionItem.id);
                                }}
                              />
                            </ToggleSwitchContainerStyled>
                          );
                        })}
                      </Box>
                    </td>
                  </PermissionRowStyled>
                </tbody>
              </table>
            );
          })}
        </td>
      </tr>
    </div>
  );
};

export default MatrixItem;
